import { render, staticRenderFns } from "./SaFlexPage.vue?vue&type=template&id=06360ca3"
import script from "./SaFlexPage.vue?vue&type=script&lang=js"
export * from "./SaFlexPage.vue?vue&type=script&lang=js"
import style0 from "./SaFlexPage.vue?vue&type=style&index=0&id=06360ca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports